import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type NotificationLevel = 'info' | 'success' | 'warning' | 'error';

export interface NotificationMessage {
  level: NotificationLevel;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly messagesSubject = new Subject<NotificationMessage>();
  readonly messages$ = this.messagesSubject.asObservable();

  info(message: string): void {
    this.publish('info', message);
  }

  success(message: string): void {
    this.publish('success', message);
  }

  warning(message: string): void {
    this.publish('warning', message);
  }

  error(message: string): void {
    this.publish('error', message);
  }

  private publish(level: NotificationLevel, message: string): void {
    this.messagesSubject.next({ level, message });
  }
}
